import { useState } from 'react';

export const useToast = () => {
  const [toast, setToast] = useState({
    open: false,
    type: 'success',
    message: '',
  });

  const showToast = (type, message) => {
    setToast({
      open: true,
      type,
      message,
    });
  };

  const hideToast = () => {
    setToast(prev => ({
      ...prev,
      open: false,
    }));
  };

  return {
    toast,
    showToast,
    hideToast,
  };
};